export default __webpack_public_path__ + "static/media/holiday-bowl.9016ac90.png";